import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../helpers/reducerRegistry'
import {
  getActiveLabelById,
  handleActiveItem,
  handleAnalysisTreeList,
  handleDataFA,
  handleTableFAData,
  handleTableFAHeader,
  handleTableFAIds,
} from '../../../helpers'
import { getFinancialAnalysis } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/peerAnalysis/financialAnalysis',
  initialState: {
    isLoading: true,
    allData: [],
    data: {
      data: [],
      unit: undefined,
    },
    dataTable: {},
    tableIds: [],
    tableHeader: [],
    treeList: [],
    activeItem: null,
    activeItemLabel: null,
    showListChart: [],
  },
  reducers: {
    changeData: (state, action) => {
      state.data = action.payload
      state.tableIds = handleTableFAIds(state.data.data)
      state.tableHeader = handleTableFAHeader(state.data.data)
      state.dataTable = handleTableFAData(
        state.data.data,
        state.tableIds,
        state.tableHeader,
        state.data.unit,
      )
    },
    changeActiveItem: (state, action) => {
      const { id, label } = action.payload
      state.activeItem = id
      state.activeItemLabel = label
    },
    changeListChart: (state, { payload }) => {
      state.showListChart = payload
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getFinancialAnalysis.pending, (state) => {
      state.allData = []
      state.treeList = []
      state.activeItem = null
      state.activeItemLabel = null
      state.data = {
        data: [],
        unit: undefined,
      }
      state.tableIds = []
      state.tableHeader = []
      state.dataTable = {}
      state.isLoading = true
    })

    builder.addCase(
      getFinancialAnalysis.fulfilled,
      (state, { payload = [] }) => {
        state.isLoading = false
        const data = payload
        if (!data.length) return
        state.allData = data
        state.treeList = handleAnalysisTreeList(data)
        state.activeItem = handleActiveItem(data, state.activeItem)
        state.activeItemLabel = getActiveLabelById(data, state.activeItem)
        state.data = handleDataFA(data, state.activeItem)
        state.tableIds = handleTableFAIds(state.data.data)
        state.tableHeader = handleTableFAHeader(state.data.data)
        state.dataTable = handleTableFAData(
          state.data.data,
          state.tableIds,
          state.tableHeader,
          state.data.unit,
        )
      },
    )

    builder.addCase(getFinancialAnalysis.rejected, (state) => {
      state.isLoading = false
    })
  },
})

export const getTreeList = (state) => state[slice.name].treeList
export const selectActiveItem = (state) => state[slice.name].activeItem
export const selectActiveItemLabel = (state) =>
  state[slice.name].activeItemLabel

export const selectTableItem = (rowId, colId) => (state) => {
  return state[slice.name].dataTable[rowId][colId]
}
export const selectTableIds = (state) => state[slice.name].tableIds
export const selectShowListChart = (state) => state[slice.name].showListChart
export const selectDataTable = (state) => state[slice.name].dataTable
export const selectTableHeader = (state) => state[slice.name].tableHeader
export const selectIsLoading = (state) => state[slice.name].isLoading
export const selectRowDataTable = (rowId) => (state) =>
  state[slice.name].dataTable[rowId]

export const { changeData, changeActiveItem, changeListChart } = slice.actions

register(slice.name, slice.reducer)
